// extracted by mini-css-extract-plugin
export default {"newResourceBox":"styles_newResourceBox__bQ+Ck","newResourceBoxInner":"styles_newResourceBoxInner__EMQFz","logo":"styles_logo__+Dy6Q"};